<template>
  <div class="ba-switch"
       :class="[size, theme]">
    <button :class="{ active: realValue, disabled: disabled }"
            :style="{ width: width + 'px', 'background-color': color }"
            @click="onChange">
      <span class="pin"
            :class="{ on: realValue, off: !realValue}"
            :style="{ left: offPinPosition + 'px' }">
        <i v-if="onIcon" class="icon on" :class="onIcon"/>
        <i v-if="offIcon" class="icon off" :class="offIcon"/>
      </span>
      <label class="on" v-html="onLabel"></label>
      <label class="off" v-html="offLabel"></label>
    </button>
  </div>
</template>

<script>
export default {
  name: 'BaSwitch',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    default: {
      default: true
    },
    value: {
      default: undefined
    },
    onValue: {
      default: true
    },
    offValue: {
      default: false
    },
    onLabel: {
      type: String,
      default: 'ON'
    },
    offLabel: {
      type: String,
      default: 'OFF'
    },
    onColor: {
      type: String,
      default: '#64b950'
    },
    offDarkColor: {
      type: String,
      default: '#555555'
    },
    onDarkColor: {
      type: String,
      default: '#64b950'
    },
    offColor: {
      type: String,
      default: '#d7d7d7'
    },
    onIcon: {
      type: String
    },
    theme: {
      type: String
    },
    offIcon: {
      type: String
    },
    width: {
      type: Number,
      default: 53
    },
    size: {
      type: String,
      default: 'medium'
    }
  },
  computed: {
    color () {
      if (this.theme === 'dark') {
        return this.realValue ? this.onDarkColor || this.onColor : this.offDarkColor || this.offColor
      }
      return this.realValue ? this.onColor : this.offColor
    },
    offPinPosition () {
      if (this.size === 'xsmall') {
        return this.realValue ? this.width - 14 - 2 : 2
      } else if (this.size === 'small') {
        return this.realValue ? this.width - 16 - 3 : 3
      }
      return this.realValue ? this.width - 19 - 3 : 3
    }
  },
  watch: {
    value (value) {
      if (value === this.onValue) {
        this.realValue = true
      } else {
        this.realValue = false
      }
    }
  },
  created () {
    let initValue = this.value || this.default
    if (initValue === this.onValue) {
      this.realValue = true
    } else {
      this.realValue = false
    }
  },
  methods: {
    onChange () {
      if (!this.disabled) {
        if (this.value === undefined) {
          this.realValue = !this.realValue
        }
        this.$emit('change', this.realValue ? this.onValue : this.offValue)
      }
    }
  },
  data () {
    return {
      realValue: null
    }
  }
}
</script>

<style lang="scss" scoped>
.ba-switch {
  display: inline-block;
  vertical-align: middle;

  &.dark {
    .pin.off {
      background-color: #bbbbbb;
    }

    label.off {
      color: #bbbbbb;
    }
  }

  button {
    position: relative;
    height: 25px;
    border-radius: 13px;
    transition: background-color 0.2s ease;
    vertical-align: middle;
    margin-top: -0.5px;

    * {
      cursor: pointer;
    }

    .pin {
      position: absolute;
      top: 3px;
      left: 3px;
      display: block;
      width: 19px;
      height: 19px;
      border-radius: 10px;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.18);
      background-color: #ffffff;
      transition: left 0.3s cubic-bezier(.28,.12,.42,.94);

      i {
        @include positionXYcenter;
        transition: opacity 0.3s ease;

        &.on {
          opacity: 0;
        }

        &.off {
          opacity: 1;
        }
      }
    }

    label {
      position: absolute;
      top: 0;
      line-height: 25px;
      display: block;
      color: #ffffff;
      font-size: 12px;
      font-weight: 500;
      text-align: center;
      transition: width 0.3s cubic-bezier(.28,.12,.42,.94);
      overflow: hidden;

      &.on {
        left: 0;
        width: 0;
      }

      &.off {
        right: 0;
        width: calc(100% - 19px);
      }
    }

    &.active {
      .pin {
        i {
          &.on {
            opacity: 1;
          }

          &.off {
            opacity: 0;
          }
        }
      }

      label {
        &.on {
          width: calc(100% - 19px);
        }

        &.off {
          width: 0 !important;
        }
      }
    }

    &.disabled {
      cursor: not-allowed;
      opacity: 0.3;

      * {
        cursor: not-allowed;
      }
    }
  }

  &.xsmall {
    button {
      height: 18px;

      .pin {
        top: 2px;
        left: 2px;
        width: 14px;
        height: 14px;
      }

      label {
        font-size: 10px;
        line-height: 22px;

        &.off {
          width: calc(100% - 14px);
        }
      }

      &.active {
        label {
          &.on {
            width: calc(100% - 16px);
          }
        }
      }
    }
  }

  &.small {
    button {
      height: 22px;

      .pin {
        width: 16px;
        height: 16px;
      }

      label {
        font-size: 10px;
        line-height: 23px;

        &.off {
          width: calc(100% - 16px);
        }
      }

      &.active {
        label {
          &.on {
            width: calc(100% - 16px);
          }
        }
      }
    }
  }
}
</style>
